/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

'use strict';

var timeout = require('../../utils/promise/timeout');
var tracker = require('../../utils/logger/timeTracker');

var splitChangesService = require('../../services/splitChanges');
var splitChangesRequest = require('../../services/splitChanges/get');

function splitChangesFetcher(settings, since) {
  var shouldApplyTimeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  tracker.start(tracker.C.SPLITS_FETCH);
  var requestPromise = splitChangesService(splitChangesRequest(settings, since));

  if (shouldApplyTimeout) {
    requestPromise = timeout(settings.startup.requestTimeoutBeforeReady, requestPromise);
  }

  return requestPromise.then(function (resp) {
    tracker.stop(tracker.C.SPLITS_FETCH);
    return resp;
  }).then(function (resp) {
    return resp.json();
  });
}

module.exports = splitChangesFetcher;


//////////////////
// WEBPACK FOOTER
// ../~/@splitsoftware/splitio/lib/producer/fetcher/SplitChanges.js
// module id = 1215
// module chunks = 0